import React from "react";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";
import useGetData from "../Custom-Hooks/useGetData";
import { getCurrentFormattedMonthYear } from "../../utils/dateUtils";
import GlobalLoader from "../shared/GlobalLoader";

const PSM = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const selectedCustomerId = localStorage.getItem("customerId") || 0;
  const selectedLocationId = localStorage.getItem("selectedLocationId") || 0;
  const currentdate = getCurrentFormattedMonthYear();

  const { data: psmDataEdited, isLoading: isLoading } = useGetData(
    `${baseUrl}/customer/psm/${selectedCustomerId}/${selectedLocationId}`
  );

  const psmData = psmDataEdited?.overlay?.psmData;
  const mi = psmDataEdited?.overlay?.psmData["MI (Mechanical Integrity)"];
  const ndt = psmDataEdited?.overlay?.psmData["NDT (Non-Destructive Testing)"];

  const totalIssues =
    (mi?.EquipementData?.data?.length || 0) +
    (ndt?.EquipementData?.data?.length || 0) +
    (ndt?.pipeData?.data?.length || 0);

  const ndtData = [
    {
      label: "Pipes",
      type: "NDT",
      hasIssues: ndt?.pipeData?.data?.length > 0,
    },
    {
      label: "Equipment",
      type: "NDT",
      hasIssues: ndt?.EquipementData?.data?.length > 0,
    },
  ];

  const miData = [
    {
      label: "Equipment",
      type: "MI",
      hasIssues: mi?.EquipementData?.data?.length > 0,
    },
  ];

  const ispsmDataEmpty = !psmData || Object.keys(psmData).length === 0;

  return (
    <div>
      {isLoading && <GlobalLoader />}
      <div className="col-12 px-3 py-4 d-flex flex-column flex-md-row align-items-center justify-content-between">
        <div>
          <div className="fnt14 fw-600">PSM</div>
          {psmDataEdited?.updated_at &&
            <div className="fnt12 fw-500 text-secondary">
              MEB&nbsp;–&nbsp;
              {new Date(psmDataEdited.updated_at).toLocaleDateString('en-US', {
                month: 'short',
                year: 'numeric'
              })}
            </div>
          }
        </div>
        <div className="default-button">{totalIssues} Issues</div>
      </div>

      <div className="row">
        <div className="col-12">
          <div>
            <ul
              className="nav nav-pills nav-custom-pills w-100 px-2"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item w-50" role="presentation">
                <button
                  className="nav-link active fnt12 fw-500 btn-lg w-100"
                  id="ndt-punch-list-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#ndt-punch-list"
                  type="button"
                  role="tab"
                  aria-controls="ndt-punch-list"
                  aria-selected="true"
                  style={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                >
                  NDT Punch List
                </button>
              </li>
              <li className="nav-item w-50" role="presentation">
                <button
                  className="nav-link fnt12 fw-500 theme-container w-100"
                  id="mi-punch-list-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#mi-punch-list"
                  type="button"
                  role="tab"
                  aria-controls="mi-punch-list"
                  aria-selected="false"
                  style={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                >
                  MI Punch List
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-12 mt-3">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="ndt-punch-list"
            role="tabpanel"
            aria-labelledby="ndt-punch-list-tab"
          >
            <div className="col-12 px-3">
              <div className="temperature-container">
                {!ispsmDataEmpty ? (
                  ndtData.map((item, index) => (
                    <div
                      key={index}
                      className={`temperature-item ${!item.hasIssues ? "disabled" : ""
                        }`}
                    >
                      <span>{item.label}</span>
                      <Link
                        to={item.hasIssues ? "/dashboard/psm" : "#"}
                        state={{
                          type: item.type,
                          category: item.label,
                          data: ndt,
                          initialTab: item.label,
                        }}
                        className={`icon-container ${item.hasIssues ? "orange" : "gray"
                          }`}
                      >
                        <FaExternalLinkAlt />
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="fnt12 d-flex align-items-center justify-content-center height-150">No data to display</div>
                )}
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="mi-punch-list"
            role="tabpanel"
            aria-labelledby="mi-punch-list-tab"
          >
            <div className="col-12 px-3">
              <div className="temperature-container">
                {!ispsmDataEmpty ? (
                  miData.map((item, index) => (
                    <div
                      key={index}
                      className={`temperature-item ${!item.hasIssues ? "disabled" : ""
                        }`}
                    >
                      <span>{item.label}</span>
                      <Link
                        to={item.hasIssues ? "/dashboard/psm" : "#"}
                        state={{
                          type: item.type,
                          category: item.label,
                          data: mi,
                          initialTab: item.label,
                        }}
                        className={`icon-container ${item.hasIssues ? "orange" : "gray"
                          }`}
                      >
                        <FaExternalLinkAlt />
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="fnt12 d-flex align-items-center justify-content-center height-150">No data to display</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PSM;